import appSettings from "../../settings/appSettings";
import { Say } from "../../languages";
import NonBreakingSpace from "./NonBreakingSpace";

type SmsOptInProps = {
  checked: boolean;
  visible?: boolean;
  onToggle: (enabled: boolean) => void;
};

export function SmsOptIn(props: SmsOptInProps) {
  const { checked, visible, onToggle } = props;
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(e.target.checked);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="form-group sms-optin-container">
      <div className="form-check">
        <label className="form-check-label" htmlFor="smsOptIn">
          <input
            type="checkbox"
            className="form-check-input"
            id="smsOptIn"
            checked={checked}
            onChange={onChange}
          />
          <NonBreakingSpace size={2} />
          <Say
            phrase="payment_step.sms_opt_in"
            mutator={(value) => appSettings.smsOptinMessage || value}
          />
        </label>
      </div>
    </div>
  );
}

export default SmsOptIn;
